import { ActionCreator } from 'redux';

import { ApplicationState } from '..';
import {
    ChangeMenuSizeAction,
    ConfigState,
    SetIsStandaloneAction,
    SetRouterBasePathAction,
    SetRtlAction,
} from './types';

export const ChangeMenuSize: ActionCreator<ChangeMenuSizeAction> = (isFolded: boolean): ChangeMenuSizeAction => ({
    type: '@@config/CHANGE_MENU_STATE',
    payload: {
        drawerMenuFolded: isFolded,
    },
});

export const SetRouterBasePath: ActionCreator<SetRouterBasePathAction> = (path: string): SetRouterBasePathAction => ({
    type: '@@config/CHANGE_ROUTER_BASE_PATH',
    payload: {
        routerBasePath: path,
    },
});

export const SetIsStandalone: ActionCreator<SetIsStandaloneAction> = (
    isStandalone: boolean
): SetIsStandaloneAction => ({
    type: '@@config/CHANGE_IS_STANDLONE',
    payload: {
        isStandalone,
    },
});

export const SetRtl: ActionCreator<SetRtlAction> = (isRtl: boolean): SetRtlAction => ({
    type: '@@config/SET_RTL',
    payload: {
        isRtl,
    },
});

export const getConfigStore = (state: ApplicationState): ConfigState => state.config;
